import { getTranslatedMeridiem } from "./localeDateTime"

const formatDateTime = dateTimeString => {
  if (!dateTimeString) return "-"
  const date = new Date(dateTimeString)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  let hours = date.getHours()
  const meridiem = getTranslatedMeridiem(hours)
  hours = hours % 12 || 12 // Convert 0 to 12 for 12-hour clock
  const minutes = String(date.getMinutes()).padStart(2, "0")
  const seconds = String(date.getSeconds()).padStart(2, "0")

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${meridiem}`
}

export default formatDateTime

// USING COMPONENT NAME: Customer, roles
